import './Navbar.css';

const Navbar = () => {
  return (
    <div className="nav">
      <div className="nav-inner">
        <div className="brand">
          <a href="/">
            <img src="/images/bar_chart_logo.svg" alt="QuickChart" /> QuickChart
          </a>
        </div>
        <div className="nav-links">
          <ul>
            <a href="/documentation/">
              <li>Docs</li>
            </a>
            <a href="/gallery/">
              <li>Chart Gallery</li>
            </a>
            <a href="/chart-maker/" className="mobile-hide">
              <li>Chart Maker</li>
            </a>
            <a href="/pricing/">
              <li>Pricing</li>
            </a>
            <a href="https://github.com/typpo/quickchart" className="mobile-hide">
              <li>Open Source</li>
            </a>
            <a href="/contact/" className="mobile-hide">
              <li>Support</li>
            </a>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
